import TravelzoForm from '../../components/CertificadoDigital';

function CertificadoDigital() {


  return (
    <>
      <TravelzoForm />
    </>
  );
}
export default CertificadoDigital;
